import { useAuth } from '../../authContext.js';
/**
 * Returns the authenticated user from {@link useAuth}.
 *
 * `UserDto.company` corresponds to the company selected in the switcher,
 * or the user's own company if no company is selected.
 */
const useIdentityUser = () => {
    const { identity: { user }, } = useAuth();
    return user;
};
export default useIdentityUser;
